module.exports = __webpack_public_path__ + "static/img/gokugoku.3ecca49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/works/gokugoku.jpg
// module id = 8rJJ
// module chunks = 0